import i18n from "@/locales";

/**
 * H5 新版帮助中心
 * */
export default [
  {
    path: "/help-center",
    name: "HelpCenterNew",
    component: () => import("@/views/help-center-new/index.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("helpCenterNew.m00000")
    }
  },
  {
    path: "/help-center/level2",
    name: "HelpCenterNewLevel2",
    component: () => import("@/views/help-center-new/level2.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("helpCenterNew.m00000")
    }
  },
  {
    path: "/help-center/level3",
    name: "HelpCenterNewLevel3",
    component: () => import("@/views/help-center-new/level3.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("helpCenterNew.m00000")
    }
  },
  {
    path: "/help-center/details",
    name: "HelpCenterNewDetails",
    component: () => import("@/views/help-center-new/details.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("helpCenterNew.m00000")
    }
  },
]
